module.exports = __webpack_public_path__ + "img/uoloadPic.7eeef408.png";